import template from './driveButton.template.html';

export default {
  template,
  bindings: {
    attachments: '<',
    ticket: '<',
    driveType: '<',
    onFinished: '&'
  },
  controllerAs: '$ctrl',
  controller: class controller {
    constructor($rootScope, $mdDialog, eventService, uiService, ticketService) {
      'ngInject';

      const ctrl = this;
      ctrl.driveTitle = '';
      ctrl.driveIcon = '';

      ctrl.initialize = () => {
        ctrl.attachments = ctrl.attachments || [];
        ctrl.ticket = ctrl.ticket || {};
        ctrl.driveType = ctrl.driveType || '';
        ctrl.setDriveTitleAndIcon();
      };

      ctrl.setDriveTitleAndIcon = () => {
        switch (ctrl.driveType) {
          case 'dropbox':
            ctrl.driveTitle = 'Dropbox';
            ctrl.driveIcon = 'dropbox.svg';
            break;
          case 'googleDrive':
            ctrl.driveTitle = 'Google Drive';
            ctrl.driveIcon = 'googleDrive.svg';
            break;
          case 'oneDrive':
            ctrl.driveTitle = 'One Drive';
            ctrl.driveIcon = 'oneDrive.svg';
            break;
          default:
            break;
        }
      };

      ctrl.isDriveEnabled = () => {
        if (ctrl.driveType) {
          return $rootScope.CurrentAccount[
            `is${ctrl.driveType.capitalizeFirstLetter()}Enabled`
          ]();
        }
        return false;
      };

      ctrl.driveUploadOrSync = ({ event, isUpload }) => {
        if (ctrl.driveType) {
          eventService.driveUploadOrSync({
            event,
            attachments: isUpload ? ctrl.attachments.getSelected() : [],
            driveSyncs: !isUpload ? ctrl.ticket[`${ctrl.driveType}Syncs`] : [],
            idAccount: $rootScope.CurrentAccount.id,
            idTicket: ctrl.ticket.id,
            driveType: ctrl.driveType,
            title: `Choose where to ${isUpload ? 'upload' : 'sync files'}`
          });
        }
      };

      ctrl.driveUploadOrSyncFinished = (data) => ctrl.onFinished({ data });

      ctrl.driveUnsync = () => {
        let needsToUpdate = false;
        const len = ctrl.ticket[`${ctrl.driveType}Syncs`]?.length || 0;
        for (let i = 0; i < len; i += 1) {
          const driveSync = ctrl.ticket[`${ctrl.driveType}Syncs`][i];
          if (driveSync?.idAccount === $rootScope.CurrentAccount?.id) {
            const idx = _.findIndex(
              ctrl.ticket[`${ctrl.driveType}Syncs`] || [],
              (sync) => sync?.idAccount === $rootScope.CurrentAccount?.id
            );
            if (idx > -1) {
              needsToUpdate = true;
              ctrl.ticket[`${ctrl.driveType}Syncs`].splice(idx, 1);
            }
          }
        }

        if (needsToUpdate) {
          ticketService
            .updateTicket({
              id: ctrl.ticket.id,
              [`${ctrl.driveType}Syncs`]: ctrl.ticket[`${ctrl.driveType}Syncs`]
            })
            .then(() => {
              uiService.toast({
                text: {
                  p1: 'You are',
                  p2: 'unsynced',
                  p3: `from ${ctrl.driveTitle}`
                },
                delay: 1000
              });
            });
        }
      };

      ctrl.isDriveSyncEnabled = () =>
        _.some(
          ctrl.ticket[`${ctrl.driveType}Syncs`] || [],
          (sync) => sync?.idAccount === $rootScope.CurrentAccount?.id
        );

      ctrl.onDriveUploaded = () => {
        ctrl.selectedList = [];
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
